var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('login', {
    attrs: {
      "on-close-success-modal": _vm.resetState,
      "on-login": _vm.login,
      "registered-email": _vm.registeredEmail,
      "demo-accessed": _vm.demoAccessed
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fba29bf2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Login/LoginContainer.vue
// module id = 826
// module chunks = 0